// extracted by mini-css-extract-plugin
export default {"localNavHeader":"KKS1OGWbLpwTeHXOBOWf","onScroll":"g3HmrczvH5cYyLV91hVi","navbar":"Gf5a1AhnqggQ5BQN3i_0","navbarDivider":"WEXcxnc0zSPuHorpQ08P"};